import { render, staticRenderFns } from "./StatusColumnTemplate.vue?vue&type=template&id=5452c98c&scoped=true"
import script from "./StatusColumnTemplate.vue?vue&type=script&lang=js"
export * from "./StatusColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./StatusColumnTemplate.vue?vue&type=style&index=0&id=5452c98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452c98c",
  null
  
)

export default component.exports